import { React, useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/authContext';
import { Link, useNavigate } from 'react-router-dom';

import { IconBuildingEstate, IconHeartFilled, IconHeart, IconArrowUp } from '@tabler/icons-react';
import { Loader, ActionIcon, Select } from '@mantine/core';
import { format, parseISO } from 'date-fns';

import Box from '../../../composents/Boxes/Standard/Box';
import AppNavbarSyndic from '../../Navbar/NavbarApp';
import RessourceOptions from '../../../components/Constants/RessourcesOptions'

const FavOffersList = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const { getToken } = useContext(AuthContext);
    const [listOffer, setlistOffer] = useState([]);
    const [favOffers, setFavOffers] = useState([]);
    const [pendingFavs, setPendingFavs] = useState(() => new Set());
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [contratFilter, setContratFilter] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        getAllOffers();
        getFavOffers();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 400);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getAllOffers  = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/offers/favlist/full",
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const list = await response.json();
            setlistOffer(Array.isArray(list) ? list : []);
        } catch (error) {
            return null;
        }
    };

    const getFavOffers = async () => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        try {
        const res = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/offers/favlist/full", {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setFavOffers(Array.isArray(data) ? data.map(offer => offer._id.toString()) : []);
        } catch (err) {
            console.error(err);
            setFavOffers([]);
        }
    };
    
    const toggleFavorite = async (offerId) => {
        const key = offerId.toString();
        if (pendingFavs.has(key)) return;

        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }

        setPendingFavs(prev => new Set(prev).add(key));
        try {
            const isFav = favOffers.includes(key);
            const url = isFav
                ? `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/delfavfulllist/${offerId}`
                : `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/addfavfulllist/${offerId}`;
            const method = isFav ? "DELETE" : "POST";

            const newFavs = isFav
                ? favOffers.filter(id => id.toString() !== key)
                : [...favOffers, key];
            setFavOffers(newFavs);

            const res = await fetch(url, {
                method,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const updatedFavs = await res.json();
            setFavOffers(updatedFavs.map(offer => offer._id.toString()));

            if (method === "DELETE") {
                setlistOffer(prev => prev.filter(offer => offer._id !== offerId));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setPendingFavs(prev => {
                const next = new Set(prev);
                next.delete(key);
                return next;
            });
        }
    };

    const filteredOffers = contratFilter
        ? listOffer.filter(offer => offer.contrat === contratFilter)
        : listOffer;

    return(

        listOffer || RessourceOptions ?
            <>
                {isMobile ? (
                    <>
                        <AppNavbarSyndic/>
                        {listOffer.length > 0 && (
                            <div className="width95pCenter mrgT5">
                                <Select
                                    variant="filled"
                                    placeholder="Type d'offre"
                                    data={[
                                        { value: "Vente", label: "Vente" },
                                        { value: "Location", label: "Location" },
                                        { value: "Don", label: "Don" },
                                    ]}
                                    value={contratFilter}
                                    onChange={(v) => setContratFilter(v || "")}
                                    clearable
                                />
                            </div>
                        )}
                        <div className="mrgB75">
                            <>
                                {listOffer.length <= 0
                                    ?   <div className='vertical txtCenter noMrgTB'>
                                            <p className='dGreyT mrgT20 mrgB5 txt15'>Ajoutez des offres à vos favoris via l’icône cœur. <span className='txt20'>♡</span></p>
                                        </div>
                                    :   filteredOffers.length <= 0
                                    ?   <div className='vertical txtCenter noMrgTB'>
                                            <p className='dGreyT mrgT20 mrgB5 txt15'>Aucun résultat trouvé</p>
                                        </div>
                                    :   <>
                                            {filteredOffers.map((offer, index) => {
                                                const isFavorite = favOffers.some(id => id.toString() === offer._id.toString());

                                                return (
                                                <div key = {index} style = {{ position: "relative", margin: '5px 5px' }}>
                                                        <div
                                                            style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", zIndex: 2 }}
                                                            onClick={(e) => { e.preventDefault(); toggleFavorite(offer._id); }}
                                                            >
                                                            {isFavorite ? (
                                                                <IconHeartFilled size={22} color="gray" />
                                                            ) : (
                                                                <IconHeart size={22} color="gray" />
                                                            )}
                                                        </div>
                                                        <Link to={`/app/offers/offer/${offer._id}`} className="aReset bT">               
                                                            <Box>
                                                                <div className="horizontal iCenter">                                                       <div className='mrgR20 noMrgTB'>   
                                                                        {offer.pictures.length > 0 
                                                                            ?   <div>
                                                                                    <img 
                                                                                        className="roundImg70"
                                                                                        src={offer.pictures[0]}
                                                                                        alt='photo_chantier'/>
                                                                                </div>
                                                                            :   <>
                                                                                    {offer.author?.company?.logo
                                                                                        ?   <div>
                                                                                                <img    
                                                                                                    className="roundImg70"
                                                                                                    src={offer.author?.company?.logo}
                                                                                                    alt='logo'/>
                                                                                            </div>
                                                                                            
                                                                                        :   <> {offer.author?.company
                                                                                                ? <div className="noAvatarProfileAccount">{offer.author?.company?.name.split(" ").map((word) => word.charAt(0)).join("")}</div>
                                                                                                :  <div className="noAvatarProfileAccount"><IconBuildingEstate height={65}></IconBuildingEstate></div>
                                                                                                }
                                                                                            </>
                                                                                    }
                                                                                </>     
                                                                        }                                                                      
                                                                    </div>
                                                                    <div className="vertical w100">
                                                                        <div className="horizontal iCenter" style={{ paddingRight: 32 }}>
                                                                            <p className="txt15 mediumplus noMrgTB cap finalDots" style={{ minWidth: 0, flex: 1 }}>{offer.title}</p>
                                                                            <span style={{ flexShrink: 0, marginLeft: 6, backgroundColor: "#2e7d32", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>
                                                                                {offer.contrat === "Location" ? "LOC" : offer.contrat === "Don" ? "DON" : "VTE"}
                                                                            </span>
                                                                        </div>
                                                                        <div className='horizontal'>
                                                                            <div>
                                                                                <p className="txt15 mediumplus noMrgTB cap mrgR5">{offer.price?.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</p>
                                                                            </div>
                                                                            {(offer.contrat === "Location" &&                                                    
                                                                            <div>
                                                                                <p className="txt15 mediumplus noMrgTB cap mrgL5">/ jour</p>
                                                                            </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="horizontal iCenter noMrgTB">
                                                                            <p className="noMrg txt13 jumpline finalDotsMed">{RessourceOptions.find(option => option.value === offer.ressource)?.group || ""}</p>
                                                                        </div>
                                                                        <div className="horizontal iCenter">
                                                                            <p className="noMrg txt13 finalDotsMed">{offer.cityOfIntervention}</p>
                                                                        </div>
                                                                            <div className="horizontal iStart">
                                                                            <p className="txt13 noMrgTB mrgR5 txtCenter">
                                                                                {format(parseISO(offer.createdAt), 'dd/MM/yy')}
                                                                            </p>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            </Box>
                                                        </Link>
                                                </div>
                                            );
                                            })}
                                        </> 
                                }
                            </>
                                
                        </div>
                        
                    </>
                ) : (
                    <>
                        <AppNavbarSyndic/>
                        {listOffer.length > 0 && (
                            <div className="width90pCenter" style={{ marginTop: 40, display: "flex", justifyContent: "center" }}>
                                <div style={{ width: 960, display: "flex", justifyContent: "flex-start" }}>
                                    <Select
                                        variant="filled"
                                        placeholder="Type d'offre"
                                        data={[
                                            { value: "Vente", label: "Vente" },
                                            { value: "Location", label: "Location" },
                                            { value: "Don", label: "Don" },
                                        ]}
                                        value={contratFilter}
                                        onChange={(v) => setContratFilter(v || "")}
                                        clearable
                                        style={{ width: 160 }}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="width90pCenter mrgB100" style={{ marginTop: listOffer.length > 0 ? 8 : 40 }}>
                            <>
                                {listOffer.length <= 0
                                    ?   <div className='vertical txtCenter noMrgTB'>
                                            <p className='dGreyT mrgT20 mrgB5 txt15'>Ajoutez des offres à vos favoris via l'icône cœur. <span className='txt20'>♡</span></p>
                                        </div>
                                    :   filteredOffers.length <= 0
                                    ?   <div className='vertical txtCenter noMrgTB'>
                                            <p className='dGreyT mrgT20 mrgB5 txt15'>Aucun résultat trouvé</p>
                                        </div>
                                    :   <div style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, 320px)",
                                            gap: 20,
                                            justifyContent: "center"
                                        }}>
                                            {filteredOffers.map((offer, index) => {
                                                const isFavorite = favOffers.some(id => id.toString() === offer._id.toString());

                                                return (
                                                <div key = {index} style = {{ position: "relative" }}>
                                                        <div
                                                            style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", zIndex: 2 }}
                                                            onClick={(e) => { e.preventDefault(); toggleFavorite(offer._id); }}
                                                            >
                                                            {isFavorite ? (
                                                                <IconHeartFilled size={22} color="gray" />
                                                            ) : (
                                                                <IconHeart size={22} color="gray" />
                                                            )}
                                                        </div>
                                                        <Link to={`/app/offers/offer/${offer._id}`} className="aReset bT">
                                                            <Box>
                                                                <div className="horizontal iCenter">
                                                                    <div className='mrgR20 noMrgTB'>
                                                                        {offer.pictures.length > 0
                                                                            ?   <div>
                                                                                    <img
                                                                                        className="roundImg70"
                                                                                        src={offer.pictures[0]}
                                                                                        alt='photo_chantier'/>
                                                                                </div>
                                                                            :   <>
                                                                                    {offer.author?.company?.logo
                                                                                        ?   <div>
                                                                                                <img
                                                                                                    className="roundImg70"
                                                                                                    src={offer.author?.company?.logo}
                                                                                                    alt='logo'/>
                                                                                            </div>

                                                                                        :   <> {offer.author?.company
                                                                                                ? <div className="noAvatarProfileAccount">{offer.author?.company?.name.split(" ").map((word) => word.charAt(0)).join("")}</div>
                                                                                                :  <div className="noAvatarProfileAccount"><IconBuildingEstate height={65}></IconBuildingEstate></div>
                                                                                                }
                                                                                            </>
                                                                                    }
                                                                                </>
                                                                        }
                                                                    </div>
                                                                    <div className="vertical w100" style={{ minWidth: 0, width: 165 }}>
                                                                        <div className="horizontal iCenter" style={{ width: 165, paddingRight: 28 }}>
                                                                            <p className="txt15 mediumplus noMrgTB cap finalDots" style={{ minWidth: 0, flex: 1 }}>{offer.title}</p>
                                                                            <span style={{ flexShrink: 0, marginLeft: 6, backgroundColor: "#2e7d32", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>
                                                                                {offer.contrat === "Location" ? "LOC" : offer.contrat === "Don" ? "DON" : "VTE"}
                                                                            </span>
                                                                        </div>
                                                                        <div className='horizontal'>
                                                                            <div>
                                                                                <p className="txt15 mediumplus noMrgTB cap mrgR5">{offer.price?.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</p>
                                                                            </div>
                                                                            {(offer.contrat === "Location" &&
                                                                            <div>
                                                                                <p className="txt15 mediumplus noMrgTB cap mrgL5">/ jour</p>
                                                                            </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="horizontal iCenter noMrgTB">
                                                                            <p className="noMrg txt13 jumpline finalDotsMed" style={{ width: 165 }}>{RessourceOptions.find(option => option.value === offer.ressource)?.group || ""}</p>
                                                                        </div>
                                                                        <div className="horizontal iCenter">
                                                                            <p className="noMrg txt13 finalDotsMed" style={{ width: 165 }}>{offer.cityOfIntervention}</p>
                                                                        </div>
                                                                            <div className="horizontal iStart">
                                                                            <p className="txt13 noMrgTB mrgR5 txtCenter">
                                                                                {format(parseISO(offer.createdAt), 'dd/MM/yy')}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </Box>
                                                        </Link>
                                                </div>
                                            );
                                            })}
                                        </div>
                                }
                            </>

                        </div>

                        {showScrollTop && (
                            <ActionIcon
                                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                radius="xl"
                                size={50}
                                color="dark"
                                variant="filled"
                                style={{ position: "fixed", bottom: 30, right: 30, zIndex: 100 }}
                                >
                                <IconArrowUp size={24} />
                            </ActionIcon>
                        )}
                    </>
                )}
            </> 
        : 
         <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    ) 
}

export default FavOffersList;

